<template>
	<div class="newsList">
    <banner></banner>  
    <div class="minW">
      <div class="comm-pd news-filter">
        <div class="filter-title">{{pidCategName}}</div>
        <div class="filter-checkbox">
          <div class="checkbox-items">
            <div class="checkbox-inline" :class="{'checked':item.id==selectArticleId}" 
              v-for="item in catgList"
              :key="item.id"
              @click="handleChange(item.id)">
              <label :for="item.id">{{item.categName}}</label>
            </div>
          </div>
        </div>
        <div class="search-contain">
          <div class="search-input">
            <el-input v-model="searchKey" placeholder="搜索" @keyup.enter="getArticleList">
              <template #prefix>
                <el-icon class="el-input__icon" @click="getArticleList"><search /></el-icon>
              </template>
            </el-input>
          </div>
          <div class="style-type">
            <div class="type-btn" :class="{'selected':styleType==1}" @click="changeStyle"><text class="iconfont" style="font-size:19px">&#xe62b;</text></div>
            <div class="type-btn" :class="{'selected':styleType==2}" @click="changeStyle"><text class="iconfont">&#xe626;</text></div>
          </div>
        </div>
      </div>
      <div class="news-list" v-if="articleList&&articleList.length>0">
        <ul class="style1" v-if="styleType==1">
          <li class="comm-pd" v-for="item in articleList" :key="item.id" @click="jumper(item.id)">
            <div class="date">
              <div class="date-day">{{item.publishDate[2]}}</div>
              <div class="date-year-mon">{{item.publishDate[1]}}月 {{item.publishDate[0]}}</div>
            </div>
            <div class="img">
              <img :src="commenUrl+item.pictureUrl" alt="" v-if="item.pictureUrl">
              <img src="../../assets/images/newsDefault.png" alt="" v-else>
            </div>
            <div class="msg">
              <div class="ellipsis title">{{item.title}}</div>
              <div class="ellipsis-multiline content">{{item.articleAbstract}}</div>
            </div>
          </li>
        </ul>
        <ul class="style2" v-else>
          <li v-for="item in articleList" :key="item.id" @click="jumper(item.id)">
            <div class="img">
              <img :src="commenUrl+item.pictureUrl" alt="" v-if="item.pictureUrl">
              <img src="../../assets/images/newsDefault2.png" alt="" v-else>
            </div>
            <div class="msg">
              <div class="ellipsis-multiline title">{{item.title}}</div>
              <div class="ellipsis-multiline content">{{item.articleAbstract}}</div>
              <div class="date">{{item.publishDate[0]}}/{{item.publishDate[1]}}/{{item.publishDate[2]}}</div>
            </div>
          </li>
        </ul>
        <div class="pagination-box">
          <div class="custom"><span>共{{Math.ceil(pageInfo.count/pageInfo.pageSize)}}页，{{pageInfo.count}}条资源</span></div>
          <el-pagination
            v-model:current-page="pageInfo.pageNo"
            v-model:page-size="pageInfo.pageSize"
            layout="prev, pager, next, jumper"
            :total="pageInfo.count"
            background
            @current-change="handleCurrentChange"
            small
          >
          </el-pagination>
        </div>
      </div>
      <div class="noData" v-else>
        暂无信息
      </div>
    </div>
  </div>
</template>
<script setup>
import {reactive,ref, getCurrentInstance, onMounted, computed,watch} from "vue";
import { Search,Menu,Expand } from '@element-plus/icons-vue'
import { useRouter,useRoute } from 'vue-router';
import banner from '@/components/banner.vue'
const route=useRoute();
const router=useRouter();
const {proxy}= getCurrentInstance();
//切换显示样式
const styleType = ref(1);
const changeStyle = () => {
  styleType.value = styleType.value === 1 ? 2 : 1;
};
const selectArticleId=ref("");
const articleClassIds=ref([]);
function handleChange(id){
  selectArticleId.value = id || "";
  articleClassIds.value = id ? [id] : [];
  pageInfo.pageNo = 1;
  getArticleList();
}
const pageInfo=reactive({
  pageNo:1,
  pageSize:20,
  count:0,
});
const articleList=ref([]);
const pid=ref(route.query.id);
const searchKey=ref("");
function getArticleList(){
  proxy.$request({
    url:"N_INDUSTRYARTICLEMAGE_FINDPAGELIST",
    data:{
      "articleClassIds":articleClassIds.value,
      "isShow": "0",
      "pageInfo": {
        "pageNo": pageInfo.pageNo,
        "pageSize":pageInfo.pageSize,
      },
      "pidArticleClassId":pid.value,
      "portalType": "nfstzx",
      "search": searchKey.value,
    },
    method: "post",
  }).then((res)=>{
    if(res.data.code=="000"){
      articleList.value=res.data.result.list;
      articleList.value.map(item=>{
        if(item.publishDate)item.publishDate=item.publishDate.split(" ")[0].split('-')
      })
      pageInfo.count=res.data.result.count;
    }
  }).catch((err)=>{
    console.log(err)
  })
}
//分页
function handleCurrentChange(val){
  pageInfo.pageNo=val;
  getArticleList();
}
function findNodeById(tree, targetId) {
  for (const node of tree) {
    if (node.id === targetId) return node; // 当前节点匹配 
    if (node.children?.length) {
      const found = findNodeById(node.children, targetId); // 递归子节点 
      if (found) return found;
    }
  }
  return null; // 未找到 
}
const catgList=ref([]);
const pidCategName=ref("");
function getClassList(){
  proxy.$request({
    url:"N_INDUSTRYARTICLECLASSMAGE_FINDINDUSTRYARTICLECLASSMAGETREE",
    data:{
      "portalType":"nfstzx",
      "enabledStatus":'1',
      "queryFlag":"1"
    },
    method: "post",
  }).then((res)=>{
    if(res.data.code=="000"){
      let obj=findNodeById(res.data.result,pid.value);
      if(obj){
        catgList.value=obj.children||[];
        pidCategName.value=obj.categName;
        if(route.query.selectArticleId){
          selectArticleId.value=route.query.selectArticleId
          handleChange(selectArticleId.value);
        }else{
          handleChange(catgList.value[0]?.id);
        }
      }
    }
  }).catch((err)=>{
    console.log(err)
  })
}
function init(){
  pageInfo.pageNo=1;
  articleClassIds.value=[];
  searchKey.value="";
  catgList.value=[];
  getClassList();
}
init();
watch(()=>route.query.id,(newValue,oldValue)=>{
  if(route.query.id){
    pid.value=route.query.id;
    init()
  }
});
function jumper(id){
  router.push({path:'newsDetails',query:{id:id,pid:pid.value}})
}
</script>

<style lang="less">
.newsList{
  background: #F7F7F7 ;
  /* 在线链接服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
  @font-face {
    font-family: 'iconfont';  /* Project id 5014541 */
    src: url('//at.alicdn.com/t/c/font_5014541_ch81zl2h85p.woff2?t=1757471216125') format('woff2'),
        url('//at.alicdn.com/t/c/font_5014541_ch81zl2h85p.woff?t=1757471216125') format('woff'),
        url('//at.alicdn.com/t/c/font_5014541_ch81zl2h85p.ttf?t=1757471216125') format('truetype');
  }
  .iconfont{
    font-family: 'iconfont';  /* Project id 5014541 */
  }
  .minW{
    width: 1600px;
    margin: 0 auto;
  }
  .comm-pd{
    padding: 0 30px;
  }
  
  .ellipsis-multiline{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 显示的行数，可以根据需要修改 */
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ellipsis{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .news-filter{
    display: flex;
    align-items: center;
    background: #fff;
    padding-top: 19px;
    padding-bottom: 19px;
    margin-bottom: 25px;
    border-radius: 10px;
    .filter-title{
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #595959;
      line-height: 20px;
      margin-right: 40px;
    }
    .filter-checkbox{
      display: flex;
      flex: 1;
      .all-checkbox{
        position: relative;
        padding-right: 32px;
        margin-right: 15px;
      }
      .all-checkbox:after{
        background: #D8D8D8;
        content: "";
        display: block;
        height: 18px;
        position: absolute;
        right: 0;
        top: 5px;
        width: 1px;
      }
      .checkbox-items{
        overflow:hidden;
      }
      .checkbox-inline{
        float: left;
        display: flex;
        align-items: center;
        padding: 4px 10px;
        border-radius: 4px;
        input{
          width: 16px;
          height: 16px;
          border-radius: 2px;
          border: 1px solid #000000;
          margin-right: 10px;
          opacity: 0;
        }
        label{
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #191919;
          line-height: 20px;
          cursor: pointer;
        }
      }
      .checkbox-inline.checked,.checkbox-inline:hover{
        
        label{
          color: #1663FF;
        }
      }
      .checkbox-inline:hover{
        background-color: #F5F5F5;
      }
    }
    .search-contain{
      display: flex;
      align-items: center;
      .search-input{
        margin-right: 10px;
        .el-input__wrapper{
          width: 254px;
          height: 36px;
          border-radius: 18px;
          border: 1px solid #BCBCBC;
          box-shadow:none;
        }
      }
      .style-type{
        display: flex;
        align-items: center;
        .type-btn{
          margin-left: 21px;
          cursor: pointer;
          color: #BCBCBC;
        }
        .type-btn.selected{
          color: #000000;
        }
      }
    }
  }
  .news-list{
    ul.style1{
      overflow: hidden;
      li{
        display: flex;
        align-items: center;
        height: 220px;
        background-color: #fff;
        margin-bottom: 25px;
        border-radius: 10px;
        cursor: pointer;
        .date{
          width: 100px;
          margin-right: 30px;
          text-align: center;
          .date-day{
            font-family: DIN, DIN;
            font-weight: 900;
            font-size: 46px;
            color: #191919;
            line-height: 56px;
            margin-bottom: 8px;
          }
          .date-year-mon{
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 20px;
            color: #595959;
            line-height: 28px;
          }
        }
        .img{
          width: 280px;
          height: 174px;
          margin-right: 30px;
          border-radius: 10px;
          overflow: hidden;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .msg{
          // flex: 1;
          width: calc(100% - 440px);
          .title{
            width: 100%;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 20px;
            color: #191919;
            line-height: 28px;
            margin-bottom: 25px;

          }
          .content{
            width: 100%;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #595959;
            line-height: 26px;
          }
        }
      }
    }
    ul.style2{
      overflow: hidden;
      li{
        float: left;
        width: 516px;
        height: 534px;
        margin-right: 26px;
        margin-bottom: 26px;
        background-color: #fff;
        border-radius: 10px;
        overflow: hidden;
        cursor: pointer;
        .img{
          width: 100%;
          height: 326px;
          background-color: blue;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .msg{
          padding: 24px 22px 20px;
        }
        .title{
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 20px;
          color: #191919;
          height: 64px;
          line-height: 32px;
          margin-bottom: 16px;
        }
        .content{
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #595959;
          height: 48px;
          line-height: 24px;
          margin-bottom: 16px;
        }
        .date{
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 14px;
          color: #595959;
          line-height: 20px;
        }
      }
      li:nth-child(3n){
        margin-right: 0;
      }
    }
  }
  .pagination-box{
    display: flex;
    justify-content: center;
    align-items: center;
    .custom{
      margin-right: 24px;
      span{
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #595959;
        line-height: 17px;
      }
    }
    .el-pagination.is-background .el-pager li.is-active{
      background-color: #1663FF;
    }
    .el-pagination .btn-prev{
      background-color: #F2F2F2 ;
      color: #595959;
    }
    .el-pagination.is-background .btn-next.is-disabled, .el-pagination.is-background .btn-next:disabled, .el-pagination.is-background .btn-prev.is-disabled, .el-pagination.is-background .btn-prev:disabled, .el-pagination.is-background .el-pager li.is-disabled, .el-pagination.is-background .el-pager li:disabled{
      background-color: #F2F2F2 ;
      color: #C2C2C2;
    }
  }
  .noData{
    min-height: 600px;
    background: #fff;
    text-align: center;
    padding-top: 100px;
    font-size: 14px;
    color:#999;
    border-radius: 10px;
  }
}
@media (max-width: 1680px) {
 .newsList{
  background: #F7F7F7 ;
  
  .minW{
    width: 1200px;
    margin: 0 auto;
  }
  .news-list{
    ul.style2{
      li{
        width: 382px;
      }
    }
  }
  
 }
  
}
</style>